export default __webpack_public_path__ + "static/media/insight-logo-black.9ee31d8f.svg";